jQuery(function ($) {
	if ($(window).width() > 768) { // @screen-sm-min
		$('[data-toggle="tooltip"]').tooltip({
			container: 'body',
		});
	}

	$('.datepicker').each(function () {
		$(this).datepicker({
			changeMonth: true,
			changeYear: true,
			dateFormat: 'dd-mm-yy',
			minDate: $(this).data('min'),
			maxDate: $(this).data('max'),
		});
	});
});

/**
 * When the user clicks on <div>, open the popup
 *
 * @returns {void}
 * @public
 */
export function toggleLanguageSelector () {
	const languageButtons = document.getElementsByClassName('language');
	const regionButtons = document.getElementsByClassName('region');

	for (const regBtn of regionButtons) {
		regBtn.classList.remove('show');
	}

	for (const langBtn of languageButtons) {
		langBtn.classList.toggle('show');
	}
}

/**
 * When the user clicks on <div>, open the popup
 *
 * @returns {void}
 * @public
 */
export function toggleRegionSelector () {
	const regionButtons = document.getElementsByClassName('region');
	const languageButtons = document.getElementsByClassName('language');

	for (const langBtn of languageButtons) {
		langBtn.classList.remove('show');
	}

	for (const regBtn of regionButtons) {
		regBtn.classList.toggle('show');
	}
}
